import S from "../Logger/Logger.js";
import s from "./pubsub-js/pubsub.js";
const f = function() {
  const i = /* @__PURE__ */ new Map(), o = S.getInstance();
  return {
    subscribe: function(e, t, r) {
      const n = (l, b) => {
        var u;
        let c;
        i.has(e) ? c = (u = i.get(e)) == null ? void 0 : u(t, b) : c = b, r(l, c);
      }, a = s.subscribe(e, n);
      return o.debug(`Event Service: ${e} subscribed with version ${t}.`), a;
    },
    /**
     *
     * @param subscriptionRequests
     * @param listener
     * @returns
     */
    subscribeMultiple: function(e, t) {
      return (Array.isArray(e) ? e : Array.of(e)).map((n) => {
        const a = (b, c) => {
          var v;
          let u;
          i.has(n.topic) ? u = (v = i.get(n.topic)) == null ? void 0 : v(n.version, c) : u = c, t(b, u);
        }, l = s.subscribe(n.topic, a);
        return o.debug(
          `Event Service: ${n.topic} subscribed with version ${n.version}.`
        ), l;
      });
    },
    publish: function(e, t, r) {
      r && i.set(e, r);
      const n = s.publish(e, t);
      return o.debug(`Event Service: ${e} has been published in asynchronous manner.`), n;
    },
    publishSync: function(e, t, r) {
      r && i.set(e, r);
      const n = s.publishSync(e, t);
      return o.debug(`Event Service: ${e} has been published in sychronous manner.`), n;
    },
    unsubscribe: function(e) {
      return s.unsubscribe(e);
    },
    unsubscribeMultiple: function(e) {
      return (Array.isArray(e) ? e : Array.of(e)).map((r) => f.unsubscribe(r));
    },
    countSubscriptions: function(e) {
      return s.countSubscriptions(e);
    },
    clearAllSubscriptions: function() {
      s.clearAllSubscriptions(), o.debug("Event Service: Cleared all subscriptions.");
    },
    getSubscriptions: function(e) {
      return s.getSubscriptions(e);
    }
  };
}(), d = f;
export {
  d as default
};
//# sourceMappingURL=EventService.js.map
